import React from 'react';
import { TEditRegionDetailsReduxParams, TRegion } from '~types/feat/branch';
import * as FormStyles from './_regionsDetailsForm.module.scss';
import ActionButton from '~components/atoms/ActionButton';
import LabelledDropdown from '~components/atoms/LabelledDropdown';
import { useFormik } from 'formik';
import { RegionStatusEnum } from '~utils/enums';
import Yup from '~yup';
import LabelledInput from '~components/atoms/LabelledInput';
import Text from '~components/atoms/Text';

type TBranchesDetailsForm = {
    submitButtonLabel: string;
    onSubmit: (data: TEditRegionDetailsReduxParams) => void;
    error: string;
    isEditing?: boolean;
    inputIsDisabled?: boolean;
    actionButtonIsLoading?: boolean;
    actionButtonClassName?: string;
    actionButtonIsDisabled?: boolean;
    initialRegionDetails: TRegion;
}

const RegionsDetailsForm = (props: TBranchesDetailsForm) => {
    const {
        submitButtonLabel,
        error,
        isEditing,
        inputIsDisabled,
        initialRegionDetails,
        actionButtonIsLoading,
        actionButtonClassName,
        actionButtonIsDisabled,
        onSubmit,
    } = props;

    const regionDisabled = initialRegionDetails.status === RegionStatusEnum.Deactivated;

    const statusOptions = Object.values(RegionStatusEnum).filter(e => Number.isNaN(Number(e))).map(key => {
        return {
            label: key as string,
            value: key as string,
        };
    });

    const getBranchDetailsSchema = () => Yup.object().shape({
        regionId: Yup.number(),
        regionName: Yup.string().matchNoLeadingAndTrailingWhiteSpaces().matchMaxOneWhiteSpace().required('Region name is required'),
        status: Yup.number(),
    });

    const RegionInitialValues = {
        regionId: initialRegionDetails.regionId,
        regionName: initialRegionDetails.regionName,
        status: initialRegionDetails.status,
    };

    const formik = useFormik({
        initialValues: RegionInitialValues,
        validationSchema: getBranchDetailsSchema(),
        onSubmit: values => {
            onSubmit(values);
        },
    });

    return (
        <div className={FormStyles.container}>

            <form
                onSubmit={formik.handleSubmit}
                className={FormStyles.container}
            >
                <div className={FormStyles['form-container']}>
                    <LabelledInput
                        id='regionName'
                        name='regionName'
                        label='Region Name :'
                        value={formik.values.regionName}
                        error={formik.submitCount > 0 && formik.touched.regionName ? formik.errors.regionName : undefined}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        disabled={inputIsDisabled || regionDisabled}
                    />

                    <LabelledDropdown
                        id='status'
                        name={'status'}
                        label='Status :'
                        options={statusOptions}
                        value={RegionStatusEnum[formik.values.status] || ''}
                        onChange={(e) => formik.setFieldValue('status', e.target.value === 'Active' ? RegionStatusEnum.Active : RegionStatusEnum.Deactivated)}
                        onBlur={formik.handleBlur}
                        autoComplete='off'
                        disabled={inputIsDisabled}
                        noOptionsMessage='No status found'
                        optionSelected={!!statusOptions.find(option => option.value === RegionStatusEnum[formik.values.status])}
                    />
                </div>

                <div className={`${FormStyles['button-container']} ${FormStyles['span-2']}`}>
                    <div className={FormStyles['button-subcontainer']}>
                        <ActionButton
                            label={submitButtonLabel}
                            isLoading={actionButtonIsLoading}
                            type='submit'
                            disabled={!isEditing}
                            className={actionButtonClassName}
                        />

                        <Text
                            label={error}
                            isError
                        />
                    </div>
                </div>
            </form >
        </div>
    );
};

export default RegionsDetailsForm;
